
function DefaultSlotCombinedContainer(props: any) {
  return (
    <div className="slds-col slds-p-horizontal--xx-small">
      {props.roleComponents.length > 0 ? (
        <>
          <div>{props.roleComponents}</div>
          {props.specComponents.length > 0 && <div className="slds-m-top--xx-small">{props.specComponents}</div>}
        </>
      ) : (
        <>
          {props.roleComponents} {props.specComponents}
        </>
      )}
    </div>
  );
}

export default DefaultSlotCombinedContainer;
